module.exports = __webpack_public_path__ + "img/image-charging-station-infographic-desktop.0557ad64.png";